export default __webpack_public_path__ + "static/media/menu.eb9f7993.svg";